import type { LeadSummary } from 'app/features/leads/services/gym-finder/types';

// Mixed statuses + dates so the table can demo filtering, search, and newest-first ordering
// end-to-end against the mocked Gym Finder service.
export const LEADS_FIXTURES: LeadSummary[] = [
  {
    id: 'lead-1',
    athleteName: 'Alex Morgan',
    athleteEmail: 'alex.morgan@example.com',
    athletePhone: '+44 3456 4365',
    enquiryType: 'Session request',
    status: 'active',
    receivedAt: '2026-05-20T09:30:00.000Z',
    updatedAt: '2026-05-21T10:00:00.000Z',
    signedUpForHyrox: true,
    interestedIn: 'Training',
    message: 'Hi, I would like to book an intro session at your gym.',
  },
  {
    id: 'lead-2',
    athleteName: 'Jordan Lee',
    athleteEmail: 'jordan.lee@example.com',
    athletePhone: '+44 7000 111222',
    enquiryType: 'General enquiry',
    status: 'paused',
    receivedAt: '2026-05-19T14:15:00.000Z',
    updatedAt: '2026-05-20T08:30:00.000Z',
    signedUpForHyrox: false,
    interestedIn: 'Membership',
    message: 'Could you share your class schedule and pricing?',
  },
  {
    id: 'lead-3',
    athleteName: 'Sam Taylor',
    athleteEmail: 'sam.taylor@example.com',
    athletePhone: '+44 7000 333444',
    enquiryType: 'Trial visit',
    status: 'trial',
    receivedAt: '2026-05-18T11:00:00.000Z',
    updatedAt: '2026-05-19T13:00:00.000Z',
    signedUpForHyrox: true,
    interestedIn: 'Trial visit',
    message: 'I am interested in trying a HYROX class this week.',
  },
  {
    id: 'lead-4',
    athleteName: 'Riley Chen',
    athleteEmail: 'riley.chen@example.com',
    athletePhone: '+44 7000 555666',
    enquiryType: 'Session request',
    status: 'active',
    receivedAt: '2026-05-17T16:45:00.000Z',
    updatedAt: '2026-05-18T09:45:00.000Z',
    signedUpForHyrox: false,
    interestedIn: 'Coaching',
    message: 'Looking for coaching ahead of my first race.',
  },
  {
    id: 'lead-5',
    athleteName: 'Casey Patel',
    athleteEmail: 'casey.patel@example.com',
    athletePhone: '+44 7000 777888',
    enquiryType: 'Trial visit',
    status: 'trial',
    receivedAt: '2026-05-16T08:05:00.000Z',
    updatedAt: '2026-05-17T10:20:00.000Z',
    signedUpForHyrox: true,
    interestedIn: 'Trial visit',
    message: 'Can I book a trial class on Saturday?',
  },
  {
    id: 'lead-6',
    athleteName: 'Morgan Reed',
    athleteEmail: 'morgan.reed@example.com',
    athletePhone: '+44 7000 999000',
    enquiryType: 'Membership',
    status: 'paused',
    receivedAt: '2026-05-15T12:25:00.000Z',
    updatedAt: '2026-05-16T11:10:00.000Z',
    signedUpForHyrox: false,
    interestedIn: 'Membership',
    message: 'I would like to pause my enquiry while I travel.',
  },
];
